import { stegaClean } from 'next-sanity'

import type { AcfDigitalMagazineEmbedProps } from '@typings'
import { RaContainer } from '@components/core/index.core'

import styles from './acf-digital-magazine-embed.module.scss'

export const AcfDigitalMagazineEmbed = ({ embedUrl }: AcfDigitalMagazineEmbedProps) => (
  <RaContainer>
    <div className={styles['digital-magazine-embed']}>
      <iframe
        src={stegaClean(embedUrl)}
        title="Digital Magazine"
      />
    </div>
  </RaContainer>
)
